<!--<div class="col full-height layout-column">-->

<!--  <div class="flex layout-column overflow-auto"-->
<!--       cdkDropList-->
<!--       [cdkDropListData]="jobs"-->
<!--       [cdkDropListConnectedTo]="connectedPanelIds"-->
<!--       [cdkDropListDisabled]="false"-->
<!--       (cdkDropListEntered)="enter($event)"-->
<!--       (cdkDropListDropped)="drop($event)">-->

<!--    <app-planning-draft-jobs-panel-list-item *ngFor="let job of jobs;let index = index"-->
<!--                                             [isDraft]="isDraft"-->
<!--                                             [job]="job"-->
<!--                                             [route]="routesByJobMap[job.id]"-->
<!--                                             [highlightedActivity]="highlightedActivity"-->
<!--                                             [isSelected]="selectedKeys[job.id]"-->
<!--                                             [settings]="settings"-->
<!--                                             cdkDrag-->
<!--                                             [cdkDragData]="job"-->
<!--                                             (onViewJob)="onViewJob.emit($event)"-->
<!--                                             (onToggle)="onToggleSelectedJob(job.id, $event)">-->

<!--    </app-planning-draft-jobs-panel-list-item>-->


<!--    <ng-template cdkDropListPlaceholder>-->
<!--      <div class="placeholder">Drop here</div>-->
<!--    </ng-template>-->

<!--  </div>-->
<!--</div>-->


<div class="flex full-height layout-column">

  <div *ngIf="!!jobs"
       class="flex layout-column"
       cdkDropList
       id="{{panel.id}}"
       [cdkDropListData]="jobs"
       [cdkDropListConnectedTo]="connectedPanelIds"
       (cdkDropListDropped)="drop($event)">
    <cdk-virtual-scroll-viewport *ngIf="jobs?.length"
                                 class="flex"
                                 autosize
                                 [minBufferPx]="1000"
                                 [maxBufferPx]="2000"
                                 (scroll)="onScroll($event)">
      <app-planning-draft-jobs-panel-list-item *cdkVirtualFor="let job of jobs ; trackBy: trackById; templateCacheSize: 40"
                                               [id]="job.id"
                                               [draft]="draft"
                                               [job]="job"
                                               [route]="routesByJobMap[job.id]"
                                               [routes]="routes"
                                               [highlightedActivity]="highlightedActivity"
                                               [isSelected]="selectedKeys[job.id]"
                                               [settings]="settings"
                                               [itemElementSize]="itemElementSize"
                                               [isGroupExpanded]="expandedGroupedJobs[job.id]"
                                               cdkDrag
                                               [cdkDragData]="job"
                                               [cdkDragDisabled]="routesByJobMap[job.id]?.locked"
                                               (onToggleObligateTimeWindow)="onToggleObligateTimeWindow.emit({jobIds: $event.jobIds, obligateTimeWindow: $event.obligateTimeWindow})"
                                               (onViewJob)="onViewJob.emit({jobs: $event.jobs, jobIds: $event.jobIds, event: $event.event})"
                                               (onToggle)="onToggleSelectedJob($event.jobIds, $event.isSelected)"
                                               (onContextMenu)="onContextMenu.emit({event: $event.event, job: $event.job})"
                                               (onReverseJobSplit)="onReverseJobSplit.emit({event: $event.event, job: $event.job})"
                                               (onGroupExpanded)="onGroupExpanded.emit({id: job.id, expanded: $event.expanded})">


        <div cdkDragHandle appBringozIdGenerator="drag-button-service-service-panel">
          <bringoz-icon iconName="drag" class="secondary-100"></bringoz-icon>
        </div>

        <div *ngIf="selectedIds.length > 1 && selectedKeys[job.id]">
          <div *cdkDragPreview id="app-planning-draft-jobs-panel-editable-list-preview-drag-multiple-jobs-container">
            {{ 'DRAGGING_X_ITEMS.JOBS' | translate:{X: selectedIds.length} }}
          </div>
        </div>

      </app-planning-draft-jobs-panel-list-item>
    </cdk-virtual-scroll-viewport>

    <div *ngIf="!!jobs && !jobs?.length"
         class="flex layout-row layout-align-center-center fade-element-in-only overflow-auto">
      <app-empty-state src="assets/images/empty_state/empty_state_dispatching.png"
                       text="No Services Found">

      </app-empty-state>
    </div>
  </div>

  <!--Loading Mode-->
  <app-card-skeleton *ngIf="!jobs" class="flex" [rows]="8"></app-card-skeleton>

</div>
